import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import moment from 'moment';
import { Button } from 'antd';

import PlanCancellationNotesModal from '../PlanCancellationNotesModal';
import CancelAction from './CancelAction';

import { PLAN_DATE_FORMAT } from '../../constants';
import * as actions from '../../actions';

import s from './styles.less';

const propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  setModalVisibility: PropTypes.func.isRequired,
  cancelPlan: PropTypes.func.isRequired,
  createdAt: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  cancelled: PropTypes.bool,
  cancelledAt: PropTypes.string,
  contractNumber: PropTypes.string,
};
const defaultProps = {
  cancelled: false,
  cancelledAt: null,
  contractNumber: null,
};

const PlanDetailsHeader = ({
  id,
  createdAt,
  cancelled,
  cancelledAt,
  contractNumber,
  isModalVisible,
  setModalVisibility,
  cancelPlan,
}) => (
  <Fragment>
    <Link to="/admin/plans">
      <Button type="primary" size="small" ghost>
        {'<'} Back
      </Button>
    </Link>
    <div className={s.container}>
      <div>
        <div className={s.title}>{contractNumber || `Plan #${id}`}</div>
        <div className={s.meta}>
          <span className={s.italic}>
            {moment(createdAt).format(PLAN_DATE_FORMAT)}
          </span>
          {contractNumber && <b>Plan #{id}</b>}
        </div>
      </div>
      <div>
        <CancelAction
          cancelled={cancelled}
          cancelledAt={cancelledAt}
          onCancel={() => setModalVisibility(true)}
        />
      </div>
    </div>
    <PlanCancellationNotesModal
      isVisible={isModalVisible}
      onOk={() => {
        cancelPlan(id);
        setModalVisibility(false);
      }}
      onCancel={() => setModalVisibility(false)}
    />
  </Fragment>
);

PlanDetailsHeader.propTypes = propTypes;
PlanDetailsHeader.defaultProps = defaultProps;

export default compose(
  withState('isModalVisible', 'setModalVisibility', false),
  connect(
    null,
    {
      cancelPlan: actions.cancelPlan,
    },
  ),
)(PlanDetailsHeader);
